import styled from "styled-components";

import Text from "/component/base/Text";

export const Title = styled(Text)(({ theme }) => ({
  marginBottom: theme.spacing.standard,
}));
